<template>
  <div id="map-component" :class="{ 'is-app': $isApp }">
    <div class="map-head" :class="{ 'd-block row': $isApp }">
      <div v-if="!$isApp" class="map-head-section">
        <b-btn
          primary
          iconOffMobile
          :icon="$icon('pin-transparent')"
          :loading="acquiringGeolocation"
          @click="findNearestWorkshop"
        >
          {{ $translate('closest-service', 'ZNAJDŹ NAJBLIŻSZY SERWIS') }}
        </b-btn>
      </div>
      <div v-if="!$isApp || ($isApp && !detailsModalShown && viewTypeIsMap)" class="map-head-section" :class="{ 'px-3': $isApp }">
        <FakeSelect
          :compact="$isApp"
          :model.sync="selectedRegion"
          :options="regions"
          :placeholder="$translate('province' ,'Województwo')"
          :reset="$translate('whole-country','Cała Polska')"
          @change="onRegionChange"
        />
      </div>
      <div v-if="$isApp && !detailsModalShown && viewTypeIsMap && isFiltersShown" class="map-head-section px-3">
        <FakeSelect
          button
          compact
          :placeholder="selectedServices.length ? selectedServices.map(id => this.services.find(s => s.id === id).name).join(', ') : 'Filtry'"
          @click.prevent="onAppModalClick"
        />
      </div>
      <div v-if="($isApp && detailsModalShown) || ($isApp && !viewTypeIsMap)" class="map-head-section">
        <a @click.prevent="detailsModalShown = false; viewType = 'map'" href="#" class="d-flex align-items-center font-color-black"><img :src="$icon('caret-down')" style="width: 16px; height: 16px; transform: rotate(90deg)" class="mr-2" />{{ $translate('back-to-map', 'Wróć do mapy') }}</a>
      </div>
      <div v-if="!$isApp" class="map-head-section">
        <strong class="font-color-light mr-3 mr-xl-4">{{ $translate( 'look', 'WIDOK') }}:</strong>
        <b-btn
          icon-only
          :active="viewTypeIsMap"
          :black="viewTypeIsMap"
          :light="!viewTypeIsMap"
          :icon="$icon('map-with-pin')"
          class="mr-3 mr-lg-1"
          @click="viewType = 'map'"
        >
          {{ $translate('map', 'MAPA') }}
        </b-btn>
        <b-btn
          icon-only
          :active="!viewTypeIsMap"
          :black="!viewTypeIsMap"
          :light="viewTypeIsMap"
          :icon="$icon('menu')"
          @click="viewType = 'list'"
        >
          {{ $translate('list', 'LISTA') }}
        </b-btn>
      </div>
    </div>
    <div class="map-body">
      <div class="row position-relative">
        <div
          class="col-12 hidden-padding-overflow"
          :class="{ 'col-md-7 col-lg-8 col-xl-9 pr-0': viewTypeIsMap, 'pl-0 border-0': $isApp, 'p-0': $isApp && !viewTypeIsMap }"
          :style="{ 'height': $isApp ? (viewTypeIsMap ? `${mapHeight}px` : 'calc(100vh - 52px)') : `${mapHeight}px` }"
        >
          <FiltersCanvas
            v-if="!$isApp && isFiltersShown"
            :services="services"
            :show.sync="filtersShown"
            @change="onFiltersChange"
          />
          <transition
            name="fade"
          >
            <div class="position-relative" v-if="viewTypeIsMap">
              <b-btn
                v-if="$isApp && !detailsModalShown"
                primary
                :icon="$icon('pin-transparent')"
                :loading="acquiringGeolocation"
                class="position-absolute z-index-500"
                @click="findNearestWorkshop"
              >
                {{ $translate('closest-service', 'ZNAJDŹ NAJBLIŻSZY SERWIS') }}
              </b-btn>
              <MapCanvas
                ref="map"
                :height="mapHeight"
                :loading="acquiringGeolocation"
                :lat="mapProps.lat"
                :lng="mapProps.lng"
                :zoom="mapProps.zoom"
                :pins="pins"
                :selected-pin="selectedPin"
                @click:map="onMapClick"
                @click:pin="onPinClick"
              />
            </div>
          </transition>
          <transition
            name="fade"
          >
            <ListCanvas
              v-if="!viewTypeIsMap"
              :garages="filteredGarages"
              :selected-garage="selectedGarage"
              :isMakeAnAppointment="isMakeAnAppointment"
              @click:backdrop="selectedGarage = null"
              @click:lead="openLeadModal"
              @click:item="toggleAppView"
            />
          </transition>
        </div>
        <div v-if="$isApp && viewTypeIsMap && !detailsModalShown" ref="slider" class="garages-slider">
          <ListItem
            v-for="garage in filteredGarages"
            :key="garage.id"
            :ref="`listitem-${garage.id}`"
            standalone
            :isMakeAnAppointment="isMakeAnAppointment"
            :selected="selectedGarage && selectedGarage.id === garage.id"
            :garage="garage"
            :labels-rows="1"
            @click="onGarageClick(garage)"
          />
        </div>
        <transition name="slide">
          <div 
            v-if="viewTypeIsMap && !$isApp"
            class="col-md-5 col-lg-4 col-xl-3 pl-0"
            :style="{ 'height': `${mapHeight}px` }"
          >
            <List
              :garages="filteredGarages"
              :selected-garage="selectedGarage"
              @click:item="onGarageClick"
              @click:all="viewType = 'list'"
            />
          </div>
        </transition>
      </div>
      <b-btn
        v-if="$isApp && viewTypeIsMap"
        primary
        block
        class="all-services"
        @click="viewType = 'list'"
      >
        {{ $translate('workshop-list-btn', 'ZOBACZ LISTĘ SERWISÓW') }}
      </b-btn>
    </div>

    <DetailsModal
      :show.sync="detailsModalShown"
      :garage="selectedGarage"
      :isMakeAnAppointment="isMakeAnAppointment"
      @click:lead="openLeadModal"
    />

    <div v-if="$isApp && isFiltersShown" class="modal fade" id="filters-modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Filtry <br /> <small class="font-color-orange">Wybierz usługi:</small></h5>
            <button type="button" class="close font-color-orange" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-for="s in services" :key="s.id" class="option col-12 p-0 mb-3">
              <b-checkbox
                :icon="$icon(s.icon)"
                :id="`option-${s.id}`"
                :label="s.name"
                :value="s.id"
                :model.sync="selectedServices"
              />
            </div>
          </div>
          <div class="modal-footer">
            <b-btn
              block
              primary
              data-dismiss="modal"
            >
              SZUKAJ
            </b-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ensureGeolocationPermission from './helpers/get-user-geolocation'
import { Point } from './helpers/point'
import calculateDistance from './helpers/calculate-distance'
import calculateBoundaries from './helpers/calculate-boundaries'
import { TILE_SIZE_256, calculateZoom } from './helpers/calculate-zoom'
import { getCenterCountryPoint } from './helpers/default'

import BBtn from '../shared/b-btn'
import BCheckbox from '../shared/b-checkbox'
import DetailsModal from './components/details-modal'
import FakeSelect from '../shared/fake-select'
import FiltersCanvas from './components/filters-canvas'
import ListCanvas from './components/list-canvas'
import ListItem from './components/list-item'
import List from './components/list'
import MapCanvas from './components/map-canvas'

export default {
  name: 'MapComponent',
  components: {
    BBtn, BCheckbox, DetailsModal, FiltersCanvas, FakeSelect, ListCanvas, ListItem, List, MapCanvas
  },
  props:{
    showMakeAnAppointment: {
      required: true,
      type: String,
    },
    showFilters: {
      required: true,
      type: String,
    },
    countryCode: {
      required: true,
      type: String,
    },
  },
  data () {
    return {
      acquiringGeolocation: false,
      detailsModalShown: false,
      filtersShown: false,
      garages: [],
      mapHeight: window.innerHeight - (this.$isApp ? 300 : 200),
      mapProps: {
        lat: 0,
        lng: 0,
        zoom: 0
      },
      regions: [],
      selectedGarage: null,
      selectedRegion: null,
      selectedServices: [],
      services: [],
      viewType: 'map'
    }
  },
  mounted () {
    window.EventBus.$on('resize', () => {
      this.mapHeight = window.innerHeight - (this.$isApp ? 300 : 200)
    })
    
    this.$api.getRegions(this.countryCode, (data) => {
      this.regions = data.sort((region1, region2) => region1.name.localeCompare(region2.name, "pl"));
    })

    this.$api.getGarages(this.countryCode, (data) => {
      this.garages = data
    })

    this.$api.getServices(this.countryCode, (data) => {
      this.services = data
    })

    setTimeout(() => {
      this.updateView()
    }, 500)
  },
  computed: {
    filteredGarages () {
      const sortAlphabetically = (ga, gb) => {
        const nameA = ga.city
        const nameB = gb.city
        
        return nameA.localeCompare(nameB, "pl");
      }

      if (this.selectedRegion === null && this.selectedServices.length === 0) {
        return this.garages.sort(sortAlphabetically);
      }

      const filterRegion = (garage) => {
        return garage.region.id === this.selectedRegion.id
      }

      const filterServices = (garage) => {
        for (const sid of this.selectedServices) {
          if (!garage.services.map((s) => s.id).includes(sid)) {            
            return false
          }
        }

        return true
      }

      if (this.selectedRegion === null) {
        return this.garages.filter(filterServices).sort(sortAlphabetically)
      }

      return this.garages.filter(filterRegion).filter(filterServices).sort(sortAlphabetically)
    },
    isFiltersShown () {
      if(this.showFilters === "1"){
        return true;
      }

      return false;
    },
    isMakeAnAppointment () {
      if(this.showMakeAnAppointment === "1"){
        return true;
      }

      return false;
    },
    pins () {
      return this.filteredGarages.map((garage) => {
        return [garage.lat, garage.lng]
      })
    },
    selectedPin () {
      if (this.selectedGarage === null) {
        return null
      }

      return [this.selectedGarage.lat, this.selectedGarage.lng, this.selectedGarage.name]
    },
    viewTypeIsMap () {
      return this.viewType === 'map'
    }
  },
  watch: {
    filteredGarages () {
      if (this.viewTypeIsMap) {
        return this.updateView()
      }
    },
    selectedGarage (val) {
      if (val && this.$isApp) {
        setTimeout(() => {
          if (!this.$refs.slider) {
            return
          }
          
          this.$refs.slider.scroll({
            left: this.$refs.slider.querySelector('.is-active').offsetLeft - 15,
            behavior: 'smooth'
          })
        }, 250)
      }
    },
    detailsModalShown (val) {
      if (val === false) {
        document.querySelector('html').classList.remove('fix-me')
      }
    }
  },
  methods: {
    findNearestWorkshop () {
      this.selectedServices = []
      this.selectedRegion = null
      this.acquiringGeolocation = true
      this.viewType = 'map'

      ensureGeolocationPermission()
        .then(({ coords }) => {
          const userLocation = new Point(coords.latitude, coords.longitude)
          let garageLocation
        
          let distance = null
          let minDistance = null
          let closestGarage = null
          this.garages.forEach((garage) => {
            garageLocation = new Point(garage.lat, garage.lng)
            distance = calculateDistance(userLocation, garageLocation)

            if (minDistance === null || distance < minDistance) {
              minDistance = distance
              closestGarage = garage
            }
          })

          this.selectedGarage = closestGarage

          if (this.viewTypeIsMap) {
            this.setMap({
              lat: closestGarage.lat,
              lng: closestGarage.lng,
              zoom: 9
            })
          }
        })
        .catch((reason) => {
          console.log(reason)
        })
        .finally(() => {
          this.acquiringGeolocation = false
        })
    },
    onAppModalClick () {
      $('#filters-modal').modal()
    },
    onFiltersChange (filters) {
      this.selectedServices = filters
    },
    onGarageClick (garage) {
      this.selectedGarage = garage

      setTimeout(() => {
        if (this.$isApp) {
          if (this.viewTypeIsMap) {
            document.querySelector('html').classList.add('fix-me')

            this.setMap({
              lat: garage.lat,
              lng: garage.lng,
              zoom: 9
            })
          }
        }

        this.detailsModalShown = true
      }, 25)
    },
    onMapClick () {
      this.filtersShown = false
      this.selectedGarage = null
    },
    onPinClick (pin) {
      this.filtersShown = false
      this.selectedGarage = this.garages.find((garage) => {
        return garage.lat === pin[0] && garage.lng === pin[1]
      }) || null
    },
    onRegionChange (region) {
      this.selectedServices = []
      this.selectedGarage = null

      if (region === null && this.viewTypeIsMap) {
        this.updateView()
      }
    },
    openLeadModal (g) {
      window.EventBus.$emit('lead:open', {
        garage: g || this.selectedGarage
      })
    },
    setMap (payload) {
      Object.keys(payload).forEach((key) => {
        this.mapProps[key] = payload[key]
      })

      this.$refs.map.refreshView()
    },
    toggleAppView (garage) {
      if (!this.$isApp) {
        return
      }

      this.viewType = 'map'

      setTimeout(() => {
        this.onGarageClick(garage)
      }, 250)
    },
    updateView () {
      this.selectedGarage = null
      
      const bounds = calculateBoundaries(this.filteredGarages.map((garage) => {
        return new Point(garage.lat, garage.lng)
      }))

      if (bounds.valid) {
        this.setMap({
          lat: bounds.center.lat,
          lng: bounds.center.lng,
          zoom: calculateZoom(
            bounds,
            this.$refs.map.$refs.canvas.getBoundingClientRect().width,
            this.$refs.map.$refs.canvas.getBoundingClientRect().height,
            TILE_SIZE_256
          )
        })
      } else {
        this.setMap({ ...getCenterCountryPoint(this.countryCode), zoom: 6 })
      }
    },
  }
}
</script>